import cn from 'classnames';
import get from 'lodash/get';
import Link from 'next/link';

import { usePaginationRange, DOTS } from '../../hooks/usePaginationRange';

import styles from './LayoutDynamic.module.scss';

export default function Pagination({ data, path, query }) {
  const { currentPage, lastPage, total: totalItems, perPage: itemsPerPage } = data;

  const hasPrevious = currentPage > 1;
  const hasNext = currentPage !== lastPage;
  const numberOfPages = Math.ceil(totalItems / itemsPerPage);
  const prevPage = currentPage > 1 ? currentPage - 1 : 1;
  const nextPage = currentPage + 1 < lastPage ? currentPage + 1 : lastPage;
  const category = get(query, 'category', '');

  const contentPerPage = 3;
  const buttonConst = 3;
  const siblingCount = 1;

  function getUrl(page) {
    const url = category ? `${path}?page=${page}&category=${category}` : `${path}?page=${page}`;
    return url;
  }

  const paginationRange = usePaginationRange({
    totalPageCount: numberOfPages,
    contentPerPage,
    buttonConst,
    siblingCount,
    currentPage,
  });

  return (
    <ul className={styles.pagination}>
      <li className={cn({ [styles.disabled]: !hasPrevious })}>
        <Link href={getUrl(prevPage)}>
          <a className={styles.paginationLink}>Previous</a>
        </Link>
      </li>
      {paginationRange.map((item, index) => {
        if (item === DOTS) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <button key={index} className="paginationItem">
              &#8230;
            </button>
          );
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} className={cn({ [styles.active]: currentPage === item })}>
            <Link href={getUrl(item)}>
              <a className={styles.paginationLink}>{item}</a>
            </Link>
          </li>
        );
      })}
      <li className={cn({ [styles.disabled]: !hasNext })}>
        <Link href={getUrl(nextPage)}>
          <a className={styles.paginationLink}>Next</a>
        </Link>
      </li>
    </ul>
  );
}
